import useIsSeekerEnrollment2 from '@/components/hooks/useIsSeekerEnrollment2';
import ProgressFlowNavbar from './ProgressFlowNavbar';
import ProgressTracker from './ProgressTracker';

const ProgressHeader = () => {
  const { isSeekerEnrollment2Eligible } = useIsSeekerEnrollment2();

  if (isSeekerEnrollment2Eligible) {
    return <ProgressTracker />;
  }

  return <ProgressFlowNavbar />;
};

export default ProgressHeader;
